import { render } from "./Nft2.vue?vue&type=template&id=05fb552c"
import script from "./Nft2.vue?vue&type=script&lang=ts"
export * from "./Nft2.vue?vue&type=script&lang=ts"
script.render = render

export default script